<template>
    <PopupRouterViewDetail label="Production Control Time Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Production Control Time" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Production Control Time Name" label-for="input-name" size="sm" :model.sync="model.name" :isRequired="true" :state="validateState('name')" :errorMessage="getErrorMessage(errorMessage.name, 'name')"  @change="updateData" :isUpdatable ="true"/>
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="Production Control Time Detail" :bordered="true" :items="productionControlTimeDetails" :fields="fieldsProductionControlTimeDetail" :busy="isDataLoading" :sort-by.sync="sortByProductionControlTimeDetail" :sort-desc.sync="sortDescProductionControlTimeDetail" small responsive
			@editButtonMethod="editRowDataProductionControlTimeDetail"
			@deleteButtonMethod="deleteRowDataProductionControlTimeDetail"
			@showPopupAddMethod="resetDataProductionControlTimeDetail()"
			@showPopupUploadMethod="showPopupUploadProductionControlTimeDetail()"
			@downloadMethod="downloadProductionControlTimeDetail()"
			@addFromClipboardMethod="addFromClipboardProductionControlTimeDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardProductionControlTimeDetail()"
			:showActionButton="true"
			:showEditButton="false"
			:showDeleteButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadProductionControlTimeDetail"
			>
			<template #top-row v-if="isShowProductionControlTimeDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Standar Time Name">
					<v-select append-to-body label="standarTimeName" :options="productionStandarTimes"  :value="filterProductionControlTimeDetail.standarTimeIdId" :reduce="item => item.id" v-model="filterProductionControlTimeDetail.standarTimeIdId" @search="getProductionStandarTimes" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Standar Time (Minutes)">
					<b-form-input id="input-standar-time-value-table" v-model="filterProductionControlTimeDetail.standarTimeValue" size="sm"></b-form-input>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( productionControlTimeDetailPageSize * (currentProductionControlTimeDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(standarTimeId)="row">
				<app-input-combobox-autocomplete :options="productionStandarTimes" optionsLabel="standarTimeName" optionsKey="id" :id="'input-production-control-time-detail-standar-time-id-' + row.index" label-cols-lg="12" label="Standar Time Name" size="sm" :model.sync="row.item.standarTimeIdId" :state="validateState('standarTimeIdId')" :errorMessage="getErrorMessage(errorMessage.standarTimeIdId, 'standarTimeIdId')"  @change="saveInputProductionControlTimeDetail(row.item)" :selected="row.item.standarTimeId != null ? row.item.standarTimeId.standarTimeName : ''"  @input="getProductionStandarTimes" :loading="isProductionStandarTimeComboLoading"  :isUpdatable="true"  :nolabel="true" />
			</template>
			<template v-slot:cell(standarTimeValue)="row">
				<app-input-textbox :id="'input-production-control-time-detail-standar-time-value-' + row.index" label-cols-lg="12" label="Standar Time (Minutes)" size="sm" :model.sync="row.item.standarTimeValue" :state="validateState('standarTimeValue')" :errorMessage="getErrorMessage(errorMessage.standarTimeValue, 'standarTimeValue')"   @change="saveInputProductionControlTimeDetail(row.item)" :isUpdatable="true"  :nolabel="true" :thousandSeparator="false"  />
			</template>
			<template v-slot:cell(standarTimeCategory)="row">
						<app-label label-cols-lg="12" size="sm" label="Standar Time Category" :model="(row.item.standarTimeId != null) ? (row.item.standarTimeId.standarTimeCategory != null) ? row.item.standarTimeId.standarTimeCategory.code : null : null"  />
			</template>

			<template v-slot:form-add-detail>
				<ProductionControlTimeDetailInput 
					:openPopup="isShowPopupProductionControlTimeDetail"
					:modelId="productionControlTimeDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataProductionControlTimeDetail"/>
			</template>
			<template v-slot:upload-detail>
				<ProductionControlTimeDetailUpload
					:openPopup="isShowPopupUploadProductionControlTimeDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataProductionControlTimeDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
					<app-input-textbox :id="'input-production-control-time-detail-standar-time-value-' + row.index" label-cols-lg="12" label="Standar Time (Minutes)" size="sm" :model.sync="row.item.standarTimeValue" :state="validateState('standarTimeValue')" :errorMessage="getErrorMessage(errorMessage.standarTimeValue, 'standarTimeValue')"   @change="saveInputProductionControlTimeDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
							<app-label label-cols-lg="12" size="sm" label="Standar Time Category" :model="(row.item.standarTimeId != null) ? (row.item.standarTimeId.standarTimeCategory != null) ? row.item.standarTimeId.standarTimeCategory.code : null : null"  />
				</b-card>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ProductionControlTime from '@/models/ProductionControlTime/ProductionControlTime';
import ProductionControlTimeList from '@/models/ProductionControlTime/ProductionControlTimeList';
import ProductionControlTimeFilter from '@/filters/ProductionControlTime/ProductionControlTimeFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputTextbox from '@/components/AppInputTextboxNumberCustom';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ProductionControlTimeDetail from '@/models/ProductionControlTime/ProductionControlTimeDetail';
import ProductionControlTimeDetailFilter from '@/filters/ProductionControlTime/ProductionControlTimeDetailFilter';
import ProductionStandarTime from '@/models/ProductionStandarTime/ProductionStandarTime';
import ProductionStandarTimeFilter from '@/filters/ProductionStandarTime/ProductionStandarTimeFilter';
import AppLabel from '@/components/AppLabel';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import ProductionControlTimeDetailInput from '@/views/ProductionControlTime/ProductionControlTimeDetailInput';
import ProductionControlTimeDetailUpload from '@/views/ProductionControlTime/ProductionControlTimeDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputComboboxAutocomplete,
		AppLabel,
		ProductionControlTimeDetailInput,ProductionControlTimeDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			name: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				name: { required : "Production Control Time Name is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsProductionControlTimeDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"standarTimeId": { "class" : "th-standar-time-id first-child", "label" : "Standar Time Name", key: 'standarTimeId', sortable: false}}, 
				{"standarTimeValue": { "class" : "th-standar-time-value", "label" : "Standar Time (Minutes)", key: 'standarTimeValue', sortable: false}}, 
				{"standarTimeCategory": { "class" : "th-standar-time-category last-child", "label" : "Standar Time Category", key: 'standarTimeCategory', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelProductionControlTimeDetail : {},
			isShowPopupProductionControlTimeDetail : false,
			isShowPopupUploadProductionControlTimeDetail : false,
			filterProductionControlTime : null,
			currentProductionControlTimePage : 1,
			productionControlTimePageSize: 10,
			sortByProductionControlTime: '',
			sortDescProductionControlTime: '',
			filterProductionControlTimeDetail : null,
			currentProductionControlTimeDetailPage : 1,
			productionControlTimeDetailPageSize: 10,
			sortByProductionControlTimeDetail: '',
			sortDescProductionControlTimeDetail: '',
			sortingByProductionControlTimeDetail: [],
			productionControlTimeDetails : [],
			productionControlTimeDetailId : '',
			totalProductionControlTimeDetailRow : 0,
			isShowProductionControlTimeDetailFilter: false,
			isDownloadProductionControlTimeDetail: false,
			productionStandarTimes: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isProductionStandarTimeComboLoading: false,
			isProductionControlTimeComboLoading: false,
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getProductionControlTime : async function(id) {
			this.isBusy = true;
			ProductionControlTime.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadProductionControlTime = true;
			this.filterProductionControlTime.id = this.modelId;
			ProductionControlTime.downloadDataDetail(this, this.filterProductionControlTime).then(result => {
				this.isDownloadProductionControlTime = false;
			}).catch(error => { this.isDownloadProductionControlTime = false; })
		},
		getProductionControlTimeDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterProductionControlTimeDetail);
			if (this.modelId == null) return;
			filter.productionControlTimeId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByProductionControlTimeDetail != null) {
				this.sortingByProductionControlTimeDetail[this.sortByProductionControlTimeDetail] = this.sortDescProductionControlTimeDetail;
			}
			let currentPage = (this.currentProductionControlTimeDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalProductionControlTimeDetailRow + 1;
				let page = Math.ceil(totalData/this.productionControlTimeDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.productionControlTimeDetailPageSize = 0;
			// disable paging end
			ProductionControlTimeDetail.getList(this, filter, this.sortingByProductionControlTimeDetail, currentPage , this.productionControlTimeDetailPageSize).then(result => {
				this.currentProductionControlTimeDetailPage = currentPage + 1;
				this.productionControlTimeDetails = result.data;
				this.totalProductionControlTimeDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getProductionControlTimes : async function(input) {
			let filter = new ProductionControlTimeFilter();
			if (input != undefined) {
				filter.Name = input;
			}
			this.isProductionControlTimeComboLoading = true;
			ProductionControlTime.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.productionControlTimes = result.data
				}
				this.isProductionControlTimeComboLoading = false;
			})
			.catch(error => {});
		},
		getProductionStandarTimes : async function(input) {
			let filter = new ProductionStandarTimeFilter();
			if (input != undefined) {
				filter.standarTimeName = input;
			}
			this.isProductionStandarTimeComboLoading = true;
			ProductionStandarTime.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.productionStandarTimes = result.data
				}
				this.isProductionStandarTimeComboLoading = false;
			})
			.catch(error => {});
		},
		getProductionControlTimes : async function(input) {
			let filter = new ProductionControlTimeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isProductionControlTimeComboLoading = true;
			ProductionControlTime.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.productionControlTimes = result.data
				}
				this.isProductionControlTimeComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.productionControlTimeInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					ProductionControlTime.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'productioncontroltimeindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					ProductionControlTime.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'productioncontroltimeindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ProductionControlTime.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getProductionControlTime(id);
					});
				}
			});
		},
		onHidden() {
			this.getProductionControlTimes();
		},
		addRowDataProductionControlTimeDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.productionControlTimeId =  this.modelId;
					ProductionControlTimeDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getProductionControlTimeDetails(true);
						this.isShowPopupProductionControlTimeDetail = false;
					})
				} else {
					model.productionControlTimeId =  this.modelId;
					ProductionControlTimeDetail.createDataDetail(this, model)
					.then(result => {
						this.getProductionControlTimeDetails(true);
						this.isShowPopupProductionControlTimeDetail = false;
					})
				}
			}
		},
		async editRowDataProductionControlTimeDetail(id) {
			this.productionControlTimeDetailId = id;
			this.isShowPopupProductionControlTimeDetail = true; 
		},
		async deleteRowDataProductionControlTimeDetail(id) {
			ProductionControlTimeDetail.deleteData(this, id).then(result => { this.getProductionControlTimeDetails(); });
		},
		async resetDataProductionControlTimeDetail() {
			this.productionControlTimeDetailId = "";
			this.isShowPopupProductionControlTimeDetail = true;
		},
		async addDataProductionControlTimeDetail() {
			ProductionControlTimeDetail.createData(this, { productionControlTimeId: this.modelId })
			.then(result => {
				this.getProductionControlTimeDetails(true);
			})
		},
		async addFromClipboardProductionControlTimeDetail() {
			let standarTimeIds = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					standarTimeIds.push({ standarTimeId: item, productionControlTimeId: this.modelId });
				});
				ProductionControlTimeDetail.addFromClipboard(this, standarTimeIds).then(result => { this.getProductionControlTimeDetails() });
			});
		},
		async replaceFromClipboardProductionControlTimeDetail() {
			let standarTimeIds = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					standarTimeIds.push({ standarTimeId: item, productionControlTimeId: this.modelId });
				});
				ProductionControlTimeDetail.replaceFromClipboard(this, standarTimeIds).then(result => { this.getProductionControlTimeDetails() });
			});   
		},
		showPopupUploadProductionControlTimeDetail() {
			if(this.productionControlTimeDetails != null && this.productionControlTimeDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap ProductionControlTimeDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadProductionControlTimeDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadProductionControlTimeDetail = true;
			}
		},
		uploadDataProductionControlTimeDetail(modalEvent, newDatas) {
			this.isShowPopupUploadProductionControlTimeDetail = false; 
		},
		downloadProductionControlTimeDetail(modalEvent) {
			this.isDownloadProductionControlTimeDetail = true;
			this.filterProductionControlTimeDetail.productionControlTimeId = this.modelId;
			ProductionControlTimeDetail.downloadDataDetail(this, this.filterProductionControlTimeDetail).then(result => {
				this.isDownloadProductionControlTimeDetail = false;
			}).catch(error => { this.isDownloadProductionControlTimeDetail = false; })
		},
		saveInputProductionControlTimeDetail(item) {
			if (this.productionStandarTimes != null && this.productionStandarTimes != undefined  && this.productionStandarTimes.length > 0) {
				item.standarTimeId = this.productionStandarTimes.find(q => q.id == item.standarTimeIdId);
			}
			if (this.productionControlTimes != null && this.productionControlTimes != undefined  && this.productionControlTimes.length > 0) {
				item.productionControlTime = this.productionControlTimes.find(q => q.id == item.productionControlTimeId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ProductionControlTimeDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadProductionControlTimeDetail = false; 
			this.isShowPopupProductionControlTimeDetail = false; 
			if (modalType == 'ProductionControlTimeDetail') {
				this.getProductionControlTimeDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowProductionControlTimeDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterProductionControlTime = new ProductionControlTimeFilter();
		this.filterProductionControlTimeDetail = new ProductionControlTimeDetailFilter();
		//this.getProductionStandarTimes();
		//this.getProductionControlTimes();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getProductionControlTime(id);
			} else {
				this.modelId = id;
				this.getProductionControlTime(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByProductionControlTimeDetail : {
			handler: function() {
				this.getProductionControlTimeDetails();
			}
		},
		sortDescProductionControlTimeDetail: {
			handler: function() {
				this.getProductionControlTimeDetails();
			}
		},
		currentProductionControlTimeDetailPage: {
			handler: function() {
				this.getProductionControlTimeDetails();
			}
		},
		productionControlTimeDetailPageSize : {
			handler: function() {
				this.getProductionControlTimeDetails();
			}
		},
		filterProductionControlTimeDetail: {
			handler: function() {
				this.getProductionControlTimeDetails();
			},
			deep: true,
		},
	},
}
</script>
